// Interface contract with sibling issue Task associations #12xxx; if backend
// names differ, this is the only file to change.

export const TASK_ENTITY_TYPE = 'ahoy_task';
export const TASK_STAGE_ASSOCIATION_TYPE_NAME =
  'ahoy_task_to_task_pipeline_stage';
export const TASK_OWNER_ASSOCIATION_TYPE_NAME = 'ahoy_task_to_owner';
// ahoy_task is excluded from the deal-shaped case-kind file rules
// (ahoy_file_to_deal/ahoy_deal_to_file carry target/source_excluded_entity_type_names:
// [ahoy_task]) and resolves file associations through its own dedicated
// association type instead.
export const TASK_FILE_FORWARD_ASSOCIATION_TYPE_NAME = 'ahoy_file_to_task'; // file -> task
export const TASK_FILE_REVERSE_ASSOCIATION_TYPE_NAME = 'ahoy_task_to_file'; // task -> file
